import { makeStyles } from '@mui/styles';
import React from 'react';
import { useIntl } from 'react-intl';

import type { ScheduleMode } from '../../../util/MigrationUtil';

const useStyles = makeStyles(theme => ({
    modeSelector: {
        display: 'flex',
        gap: '0px',
        borderRadius: '8px',
        border: `1px solid ${theme.palette.semantic.colorBorderDeEmp}`,
        overflow: 'hidden',
    },
    modeButton: {
        flex: 1,
        padding: '12px 24px',
        cursor: 'pointer',
        textAlign: 'center' as const,
        backgroundColor: theme.palette.semantic.colorBackground,
        border: 'none',
        fontSize: '14px',
        fontWeight: 600,
        color: theme.palette.semantic.colorForeground,
        transition: 'all 0.2s',
        '&:hover': { backgroundColor: theme.palette.semantic.colorBackgroundHover },
    },
    modeButtonActive: {
        flex: 1,
        padding: '12px 24px',
        cursor: 'pointer',
        textAlign: 'center' as const,
        backgroundColor: theme.palette.semantic.colorPrimary,
        color: theme.palette.semantic.colorForegroundInverse,
        border: 'none',
        fontSize: '14px',
        fontWeight: 600,
    },
}));

interface MigrationModeSelectorProps {
    scheduleMode: ScheduleMode;
    onModeChange: (mode: ScheduleMode) => void;
    showFlexible?: boolean;
}

export const MigrationModeSelector: React.FC<MigrationModeSelectorProps> = ({
    scheduleMode,
    onModeChange,
    showFlexible = true,
}) => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();

    return (
        <div className={classes.modeSelector}>
            <button
                type="button"
                className={scheduleMode === 'earliest' ? classes.modeButtonActive : classes.modeButton}
                onClick={() => onModeChange('earliest')}>
                {translate({ id: 'CLIENT_MIGRATION_SCHEDULE_MODE_EARLIEST' })}
            </button>
            {showFlexible && (
                <button
                    type="button"
                    className={scheduleMode === 'flexible' ? classes.modeButtonActive : classes.modeButton}
                    onClick={() => onModeChange('flexible')}>
                    {translate({ id: 'CLIENT_MIGRATION_SCHEDULE_MODE_FLEXIBLE' })}
                </button>
            )}
        </div>
    );
};
